// extracted by mini-css-extract-plugin
module.exports = {"practiceGate":"style-module__practiceGate___1HlCI","buttons":"style-module__buttons___4zW8G","rightLink":"style-module__rightLink___Vh5KX"};